<style lang="stylus" scoped>
@import '../css/var'
.cell
  display flex
  align-items center
  min-height  pt(140)

.cell-narrow
  display flex
  align-items center
  min-height pt(80)

.contentarea
 display flex
 flex-direction column
 flex-grow 1
 margin-left pt(30)

.aliColor
  color #03A0E8

.radio-icon-active
  color #30C37E
  font-size pt(45)

.radio-icon
  color #CCD5D8
  font-size pt(45)

.title
   color $normal-text-color
   font-size pt(30)

.bottom-divide
  height  1px
  width 100%
  background #CCD5D8
</style>
<template>
  <div>
    <div :class="getOuterClass()"  @click="click">
      <slot name='icon'></slot>
      <div class="contentarea" :style="{'margin-left': $slots.icon  ? '10pt' : '0'}">
        <div class="title">{{ nameString }}</div>
        <slot name='balance'></slot>
      </div>
      <i :class="name === value ? 'radio-icon-active' : 'radio-icon'" class="icon">&#xe6a7;</i>
    </div>
    <div class="bottom-divide"></div>
  </div>
</template>
<script>
export default {
  props: {
    value: '',
    name: '',
    nameString: ''
  },
  methods: {
    click () {
      this.$emit('input', this.name)
    },
    getOuterClass () {
      if (this.$slots.icon || this.$slots.balance) {
        return 'cell'
      } else {
        return 'cell-narrow'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// radio.vue?dbac1c0a